const themeStore = {
    alert: { title: '', subtitle: '', active: false, type: 'error' },
    loading: false,
    pageTitle: '',
    sideBar: false,
    language: 'en'
}

export default themeStore